import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Initialize i18next
i18n
    .use(HttpBackend) 
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        fallbackLng: 'es', // Default language
        debug: false, // Enable debug mode
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
            requestOptions: {
                cache: 'default', // Improve caching for Firefox
            },
            // Add cross-origin configuration for better browser compatibility
            crossDomain: true,
            // Add timeout for better reliability
            loadTimeout: 30000, // 30 seconds timeout
        },
        // Language detection configuration for better Firefox compatibility
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
            // Add excludeCacheFor for better Firefox compatibility
            excludeCacheFor: ['cimode'],
        },
        ns: ['other', 'b2b-common', 'b2b-frameworks', 'b2b-indicators',
            'b2b-languages', 'b2b-mar-ia', 'b2b-plans', 'b2b-reporting',
            'b2b-users', 'layout', 'b2b-sampling', 'b2b-logbook', 'b2b-social'], // Namespaces to load
        defaultNS: 'other', // Default namespace
        returnObjects: false, // Use key as fallback if no translation is found
        returnNull: false, // Use key as fallback if translation is null
        returnEmptyString: false, // Use key as fallback if translation is an empty string
        supportedLngs: ['es', 'ca', 'en'], // Define supported languages
        load: 'languageOnly', // Load only the language without region code
        // Improved loading configuration for Firefox
        initImmediate: false, // Don't initialize immediately, wait for resources
        preload: ['es', 'ca'], // Preload common languages
        // Add saveMissing for better debugging
        saveMissing: false, // Don't save missing keys to avoid issues
        // Add react configuration for better compatibility
        react: {
            useSuspense: false, // Disable suspense to prevent hanging in Firefox
        },
    });

export default i18n;